export default __webpack_public_path__ + "static/media/photo--sm--chris-2.df7f08fa.jpg";